import { Event } from '@/feature/event-details-sbk/types';
import { League } from '@/types/api.generated';

const leagueMappings: Array<{ league: League; names: string[] }> = [
    { league: League.Nba, names: ['nba', 'nbap', 'nba summer league', 'nba preseason'] },
    { league: League.Nfl, names: ['nfl', 'nflp', 'nfl preseason'] },
    {
        league: League.Mlb,
        names: ['major league baseball', 'mlb', 'major league baseball preseason', 'major league baseball postseason'],
    },
    { league: League.Nhl, names: ['nhl'] },
    { league: League.Wnba, names: ['wnba', 'wnba, playoffs'] },
    { league: League.Epl, names: ['epl', 'england - premier league'] },
];

// Unmapped SBK leagues render as a league with logos; TeamIcon falls back to a shield per team without one
const LEAGUE_WITH_LOGOS = League.Nba;

// Mapping league names from SBK to enums from Pickem
export const getPickemLeague = (event: Event): League => {
    const leagueName = event.league.name.toLowerCase();
    const sportName = event.sport.name.toLowerCase();

    // The legacy 'ncaa' name is shared across sports, so it needs the sport to disambiguate
    if (leagueName === 'ncaab' || (leagueName === 'ncaa' && sportName === 'basketball')) {
        return League.Cbb;
    }
    if (leagueName === 'ncaaf' || (leagueName === 'ncaa' && sportName === 'american football')) {
        return League.Cfb;
    }

    // Check each league mapping
    for (const { league, names } of leagueMappings) {
        if (names.includes(leagueName)) {
            return league;
        }
    }

    return LEAGUE_WITH_LOGOS;
};
